import { observer } from 'mobx-react';
import React from 'react';

import { Paginated } from '../../../adl-gen/common';
import { DbKey } from '../../../adl-gen/common/db';
import { Quiz } from '../../../adl-gen/totalinteraction/futurefit/db';
import { QuizReportSummary } from '../../../adl-gen/totalinteraction/futurefit/requests';
import { withI18n, WithI18nProps } from '../../../internationalization/i18n-hoc';
import { Loader, MaybeLoading } from '../../../loader/loader';
import { Route } from '../../../routing/app-routes';
import { PageLayoutFn } from '../../common/page-layout/page-layout';
import { QuizTile, TileAccordions } from '../../components/tile-accordions/tile-accordions';

interface ManagerPortalScreenProps extends WithI18nProps {
  pageLayout: PageLayoutFn;

  quizReportSummaries: MaybeLoading<Paginated<QuizReportSummary>>;

  navigateTo(route: Route): void;

  onClickQuiz(quizId: DbKey<Quiz>): void;
}

@observer
class ManagerPortalScreen0 extends React.Component<ManagerPortalScreenProps> {
  renderQuizReports = observer((quizSummaries: Paginated<QuizReportSummary>) => {
    return (
      <TileAccordions
        kind={'progress-manager'}
        quizTiles={quizSummaries.items.map((qS, index) => this.quizReportToQuizTile(qS, this.props.onClickQuiz, index))}
      />
    );
  });

  quizReportToQuizTile(
    quizReport: QuizReportSummary,
    onClickQuiz: ManagerPortalScreenProps['onClickQuiz'],
    index: number
  ): QuizTile {
    return {
      title: this.props.t(quizReport.quiz.title),
      imageUrl: quizReport.quiz.imageUrl,
      progress: quizReport.numberOfUsersCompleted,
      total: quizReport.numberOfUsers,
      id: quizReport.quizId,
      onClick: () => quizReport.numberOfUsersCompleted !== 0 && onClickQuiz(quizReport.quizId),
      enabled: true, // quizReport.numberOfUsersCompleted !== 0,
      index
    };
  }

  render() {
    return (
      <this.props.pageLayout>
        <Loader state={this.props.quizReportSummaries} LoadedComponent={this.renderQuizReports} />
      </this.props.pageLayout>
    );
  }
}

export const ManagerPortalScreen = withI18n(ManagerPortalScreen0);



// WEBPACK FOOTER //
// ./src/ui/screens/manager-portal/manager-portal.tsx